module.exports = __webpack_public_path__ + "img/sponsorB14.2c98d0c7.png";